<div class="w-full h-full p-6 flex justify-center items-center" *ngIf="showSpinner">
  <bauen-spinner *ngIf="showSpinner" [message]="spinnerMessage" class="w-full"></bauen-spinner>
</div>

<div *ngIf="!showSpinner" class="fixed inset-0 sm:static max-h-screen sm:inset-auto flex flex-col sm:min-w-[500px] sm:w-[650px] sm:rounded-3xl overflow-hidden shadow-2xl bg-white dark:bg-slate-900 border border-slate-100">
  <!-- Alert Message -->
  <fuse-alert
    class="fixed top-0 left-0 w-full flex justify-center items-center mt-8 alert-main z-99999"
    [type]="_alertConfig.type"
    [appearance]="'outline'"
    *ngIf="showAlert"
    [@fadeIn]="showAlert"
  >
    {{ _alertConfig.message }}
  </fuse-alert>

  <!-- Header con estética premium -->
  <div class="w-full px-8 py-5 bg-slate-50 dark:bg-slate-800/50 border-b border-gray-100 dark:border-slate-800 flex justify-between items-center select-none relative">
    <div class="flex items-center gap-2">
      <span class="w-1 h-6 bg-primary rounded-full"></span>
      <span class="text-brand-dark dark:text-white font-extrabold text-lg tracking-tight">
        {{ errores ? "Errores al Generar Reporte" : "Generar Reporte" }}
      </span>
    </div>
    <button mat-icon-button (click)="dialogRef.close()" class="text-slate-400 hover:bg-slate-150 hover:text-brand-primary rounded-lg transition-colors duration-200">
      <mat-icon class="text-xl">close</mat-icon>
    </button>
  </div>

  <!-- Si hay errores, muestro solo los errores -->
  <div *ngIf="errores; else generarReporte" class="max-h-[60vh] overflow-y-auto grow p-8">
    <h2 class="text-xl font-semibold text-red-650 mb-4">Se encontraron los siguientes errores:</h2>
    <div class="bg-red-50 dark:bg-red-950/20 border border-red-200 text-red-700 dark:text-red-400 px-4 py-3 rounded-2xl">
      <pre class="text-red-750 dark:text-red-400 font-mono text-sm whitespace-pre-wrap">{{ errores }}</pre>
    </div>
  </div>

  <!-- Si NO hay errores, muestro el formulario para generar reporte -->
  <ng-template #generarReporte>
    <div class="max-h-[60vh] overflow-y-auto grow p-8 pt-6">
      <form class="flex flex-col space-y-6" [formGroup]="form">
        <!-- Campo Título -->
        <div class="flex flex-col">
          <span class="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1.5">Título del Reporte</span>
          <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded-xl w-full">
            <input type="text" formControlName="titulo" matInput [placeholder]="titulo" (click)="selectAll($event)" />
          </mat-form-field>
        </div>

        <!-- Switches estilo Apple iOS para Opciones -->
        <div class="flex flex-row items-center gap-8 py-2 border-y border-slate-100 dark:border-slate-800">
          <label class="apple-switch">
            <input type="checkbox" formControlName="incluirFiltros" />
            <span class="switch-track"></span>
            <span class="switch-label">Incluir Filtros</span>
          </label>

          <label class="apple-switch">
            <input type="checkbox" formControlName="formatoPortaretrato" />
            <span class="switch-track"></span>
            <span class="switch-label">Portarretrato</span>
          </label>
        </div>

        <!-- Selección de Columnas a Exportar -->
        <div class="w-full flex flex-col">
          <div class="w-full flex justify-between items-center mb-4">
            <span class="text-sm font-bold text-slate-700 dark:text-slate-300">Selección de columnas a exportar</span>
            <label class="apple-switch scale-90">
              <input type="checkbox" formControlName="seleccionarTodo" (change)="onSeleccionarTodo($event)" />
              <span class="switch-track"></span>
              <span class="switch-label text-xs">Seleccionar Todo</span>
            </label>
          </div>

          <!-- Grid de Columnas con botón circular del prototipo de matching -->
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-3 gap-y-2 bg-slate-50/50 dark:bg-slate-800/20 p-4 rounded-2xl border border-slate-100 dark:border-slate-800">
            <div *ngFor="let columna of columnas" 
                 (click)="columna.form.setValue(!columna.form.value); onChangeColumna($event)"
                 class="flex items-center gap-3 p-2.5 rounded-xl hover:bg-slate-100/60 dark:hover:bg-slate-800/40 cursor-pointer transition-all duration-200 select-none">
              <button type="button"
                      class="w-5 h-5 rounded-full border-2 transition-all duration-200 flex items-center justify-center focus:outline-none shrink-0"
                      [ngClass]="columna.form.value ? 'bg-primary border-primary scale-110 shadow-sm text-white' : 'border-slate-300 dark:border-slate-650 bg-white dark:bg-slate-850 hover:border-primary text-transparent'">
                <mat-icon class="icon-size-3 text-white" svgIcon="heroicons_solid:check"></mat-icon>
              </button>
              <span class="text-xs font-bold text-slate-700 dark:text-slate-300">{{ columna.label }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Botonera Inferior Premium -->
    <div class="w-full flex justify-end items-center gap-3 p-6 bg-slate-50/50 dark:bg-slate-800/50 border-t border-slate-100 dark:border-slate-800 grow-0">
      <button mat-flat-button class="!border border-slate-200 border-solid rounded-xl hover:bg-slate-100 text-slate-700 dark:text-slate-300 font-semibold px-6 py-2.5 transition-all text-sm" (click)="dialogRef.close()">
        Cancelar
      </button>
      
      <button mat-flat-button color="primary" class="bg-primary rounded-xl font-semibold text-sm text-white px-6 py-2.5 shadow-sm hover:opacity-95 transition-all flex items-center gap-2" (click)="onGenerarReporte(0, endpointPdf)" [disabled]="isDisabled">
        <mat-icon class="icon-size-4" svgIcon="heroicons_solid:document-text"></mat-icon>
        Generar PDF
      </button>
      
      <button mat-flat-button color="primary" class="bg-green-600 hover:bg-green-700 rounded-xl font-semibold text-sm text-white px-6 py-2.5 shadow-sm hover:opacity-95 transition-all flex items-center gap-2" (click)="onGenerarReporte(1, endpointExcel)" [disabled]="isDisabled">
        <mat-icon class="icon-size-4" svgIcon="heroicons_solid:table-cells"></mat-icon>
        Generar Excel
      </button>
    </div>
  </ng-template>
</div>
